// extracted by mini-css-extract-plugin
export var closeButton = "_1p-1";
export var container = "_1p-0";
export var fullModalImage = "_1p-2";